import { StyleSheet, Text, View, ScrollView } from 'react-native'
import Card from '../components/shared/card/Card'

// styles
import { colorPalette, globalStyles } from '../static/styles/global'

// components
import MyScrollView from '../components/shared/navigator/MyScrollView'

// skeleton
import { skeletonStyles } from '../static/styles/skeleton'

const HomeSkeleton = () => {
  return (
    <MyScrollView>
      <View style={[globalStyles.primaryBgColor, globalStyles.containerBand]}>
        <View style={[globalStyles.vCenterItems, globalStyles.cardGap]}>
          <View style={[styles.heading]} />
          <View style={[styles.subheading]} />
          <View style={[styles.subheading]} />
          <View style={[styles.subheading]} />
        </View>
      </View>
      <View style={[globalStyles.containerOverlap]}>
        {[1, 2, 3, 4, 5].map((row) => (
          <Card key={row}>
            <View style={[globalStyles.hDirection, globalStyles.hBetweenItems]}>
              <View style={[styles.cardTitle]} />
              <View style={[styles.cardStatus]} />
            </View>
          </Card>
        ))}
      </View>
    </MyScrollView>
  )
}

const styles = StyleSheet.create({
  heading: {
    backgroundColor: colorPalette.white,
    opacity: 0.2,
    width: '70%',
    padding: 10,
    borderRadius: 10,
    marginTop: 10,
    marginBottom: 20
  },
  subheading: {
    backgroundColor: colorPalette.white,
    opacity: 0.2,
    width: '100%',
    padding: 5,
    borderRadius: 10,
    marginBottom: 10
  },
  cardTitle: {
    backgroundColor: colorPalette.lightDark,
    opacity: 0.6,
    width: '50%',
    padding: 7,
    borderRadius: 10,
    marginVertical: 5
  },
  cardStatus: {
    backgroundColor: colorPalette.lightDark,
    opacity: 0.4,
    width: '20%',
    padding: 5,
    borderRadius: 10,
    marginVertical: 5
  }
})

export default HomeSkeleton
